import {aShowDialog} from '@modifi/plugin-dialogs'
import {aReplace} from '@modifi/router'
import {ROUTE_SHIPMENTS} from '../../../routes/constants'
import {DIALOG_SUBMIT_PROGRESS, ERROR_DIALOG} from '../dialogs'

export const aShowSubmitProgressDialog = (params?: {
  fileId?: string
  documentType?: string
  fileIdent?: string
  containerId?: string
  shipmentStartDate?: string
  extractedContainerIds?: string[]
}): any => aShowDialog(DIALOG_SUBMIT_PROGRESS, params)

export const aShowErrorDialog = (params: {error: string}): any => aShowDialog(ERROR_DIALOG, params)

export const aRedirectToShipmentsOverview = (): any => aReplace(ROUTE_SHIPMENTS)
